module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAATCAYAAACp65zuAAAAbElEQVQokY3SOxWAMBBE0ReocIAp9KABB/hABz5wsVTJyWc/2fo2OzNJRIhuPy5ZZhCACzNyYY1M2CMVamiAFmqghwqMEMB6v1ucOLB8z5mmIMAMLs9EuInHw0PgFlYr1LA5ih67M6txONyMf+dQKZHWoUR3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/triangolo.png
// module id = 138
// module chunks = 0